import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../../api.service';

@Component({
  selector: 'app-select-store',
  templateUrl: './select-store.component.html',
  styleUrls: ['./select-store.component.scss']
})
export class SelectStoreComponent implements OnInit {

  @Input() StoreID: any = '0';
  @Input() mdlRef: any;
  @Input() AllOption: number = 1; // For Display all options in store
  @Input() isFromInvList: boolean = false;
  @Input() isShowAllOption: boolean = true;

  store = {
    id: 0,
    name: ''
  } 
  stores: any = [];
  jarvisData: any = [];
  agencyData:any = [];
  allStoreCnt: number = 0;
  showSupStore: boolean = false;
  relID: number = 0;

  constructor(public activeModal: NgbActiveModal, private apiService: APIService) { }

  ngOnInit(): void {

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    if (this.StoreID > 0) {
      this.store.id = this.StoreID;
    }
    //this.stores = [{ id: 1, name: 'Home' }, { id: 2, name: 'Godown' }, { id: 3, name: "Deep's home" }, { id: 4, name: "Jaimin's home" }, { id: 5, name: "Abhishek's home" }];
    this.getStores();
  }

  getStores() {
    let data = [{
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successConfigResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successConfigResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let cData = reponseData.Table2;
          let tmpStore = cData[0].Stores;
          this.stores = JSON.parse(tmpStore);
          this.allStoreCnt = this.stores.length;
          
          if(this.jarvisData[0].UserID != this.agencyData[0].AdminUserID){
            tmpStore = this.stores;
            this.stores = [];
            for(let i: number = 0; i < tmpStore.length; i++){
              if(tmpStore[i].UIDs){
                let selectedUsers = String(tmpStore[i].UIDs).split(",");
                for(let j: number = 0; j < selectedUsers.length; j++){
                  if(selectedUsers[j] == this.jarvisData[0].UserID){
                    this.stores.push(tmpStore[i]);
                  }
                }                
              }
              else{
                this.stores.push(tmpStore[i]);
              }
            }
          }
          
          if (this.showSupStore) {
            this.stores = this.stores.filter((store: any) => store.hasOwnProperty('RID') && store.RID == this.relID);
          }
          this.stores = this.stores.sort((a: any, b: any) => a.sNm.localeCompare(b.sNm));
          if (this.stores.length == 1) {
            this.store.id = this.stores[0].StrID;
            this.store.name = this.stores[0].sNm;
          }
          // if(this.stores.length == 1){
          //   this.store.id = this.stores[0].StrID;
          // }
          // else{
          //   this.store.id = 0;
          // }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  passBack() {
    this.mdlRef.close();
  }

  save() {
    let selStore = this.stores.filter((a: any) => a.StrID == this.store.id);
    if (selStore.length == 0) {
      if(this.AllOption == 0) {
        this.apiService.successAlert('Please select store');
        return;
      }
      else {
        selStore = [{ StrID: 0, sNm: "All Stores" }];
        this.mdlRef.close(selStore);
      }
    }
    else {
      this.mdlRef.close(selStore);
    }
  }

  changeStore(){
    let selStore = this.stores.filter((a: any) => a.StrID == this.store.id);
    if (selStore.length > 0) {
      this.store.id = selStore[0].StrID
    }
  }

}
